import { render, staticRenderFns } from "./JudgeService.vue?vue&type=template&id=60287970&"
import script from "./JudgeService.vue?vue&type=script&lang=js&"
export * from "./JudgeService.vue?vue&type=script&lang=js&"
import style0 from "./JudgeService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports